import { dataHooks } from '@wix/data-hooks'

export const wixStudioInviteAcceptDataHooks = dataHooks<{
  title: {}
  subTitle: {}
  next: {}
  dropdown: { optionKey: string }
}>('wixStudioInviteAccept')
